import PropTypes from 'prop-types';

export const SocketShape = PropTypes.shape({
    subscribe: PropTypes.func.isRequired,
});

export const NotificationShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    subType: PropTypes.string,
    msgParams: PropTypes.object,
});
